// third-party
import { createSlice, createSelector } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------
const dayjs = require('dayjs');

const initialState = {
    page: 0,
    rowsPerPage: 10,
    isLoading: false,
    message: '',
    costCard: [],
    customerCostingDetails: {},
    standardCosting: [],
    newCardName: '',
    // Invoicing
    pageInvoice: 0,
    rowsPerPageInvoice: 10,
    invoiceList: [],
    invoiceDetails: {},
    generatedInvoiceId: null,
    // Certificates
    pageCertificate: 0,
    rowsPerPageCertificate: 10,
    certificatesList: [],
    columnFilter: {
        invoiceId: {
            appliedList: [],
            checkedList: []
        },
        customers: {
            appliedList: [],
            checkedList: []
        },
        issuedDate: {
            appliedList: [],
            checkedList: [
                {
                    startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                    endDate: dayjs(new Date()).format('MM-DD-YYYY')
                }
            ]
        },
        status: {
            appliedList: [],
            checkedList: []
        }
    }
};

const slice = createSlice({
    name: 'costingInvoicing',
    initialState,
    reducers: {
        // Pagination
        setPage(state, action) {
            state.page = action.payload;
        },
        setRowsPerPage(state, action) {
            state.rowsPerPage = action.payload;
        },
        // invoice
        setPageInvoice(state, action) {
            state.pageInvoice = action.payload;
        },
        setRowsPerPageInvoice(state, action) {
            state.rowsPerPageInvoice = action.payload;
        },
        // certifiate
        setPageCertificate(state, action) {
            state.pageCertificate = action.payload;
        },
        setRowsPerPageCertificate(state, action) {
            state.rowsPerPageCertificate = action.payload;
        },
        // Addd
        startAddingNewCostingCard(state, action) {
            state.isLoading = true;
        },
        startMakingDefaultCosting(state, action) {
            state.isLoading = true;
        },
        // Dynamic Filter
        startDynamicFilter(state, action) {
            state.isLoading = true;
        },
        // Costing Cards
        startAllCostingCards(state, action) {
            state.isLoading = true;
        },
        setCostCard(state, action) {
            state.costCard = action.payload;
        },
        // Standard Costing Card
        startStandardCostingCard(state, action) {
            state.isLoading = true;
        },
        setStandardCostingCards(state, action) {
            state.standardCosting = action.payload;
        },
        // Customer Costing Details
        startCustomerCostingDetails(state, action) {
            state.isLoading = true;
        },
        setCustomerCostingDetails(state, action) {
            state.customerCostingDetails = action.payload;
        },
        setNewCardName(state, action) {
            state.newCardName = action.payload;
        },

        // startInvoiceList,
        // setInvoiceList,
        // startCertificateList,
        // setCertificateList,
        startInvoiceList(state, action) {
            state.isLoading = true;
        },
        setInvoiceList(state, action) {
            state.invoiceList = action.payload;
        },
        startCertificateList(state, action) {
            state.isLoading = true;
        },
        setCertificateList(state, action) {
            state.certificatesList = action.payload;
        },
        //
        //
        // Addd
        startAddingNewInvoice(state, action) {
            state.isLoading = true;
        },
        // Invoice Details
        startInvoiceDetailsById(state, action) {
            state.isLoading = true;
        },
        setInvoiceDetails(state, action) {
            state.invoiceDetails = action.payload;
        },
        setGeneratedId(state, action) {
            state.generatedInvoiceId = action.payload;
        },
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },

        // table filters
        setColumnCheckedList(state, action) {
            const { columnName, data, status, listType, newValue, columnFilterName } = action.payload;
            if (listType === 'DATE' && data) {
                //
                // data =>  startDate or endDate
                //
                let tempColumnFilterOne = { ...state[columnFilterName] };

                tempColumnFilterOne[columnName].checkedList[0][data] = newValue;
                state[columnFilterName] = { ...tempColumnFilterOne };
                tempColumnFilterOne = {};
            } else if (status) {
                // status refers to checkbox status
                // new item is checked
                // if a new item is checked it will always enter the checked list
                // data ===> id / name based on filter type
                let tempColumnFilterOne = { ...state[columnFilterName] };
                tempColumnFilterOne[columnName].checkedList.push(data);

                state[columnFilterName] = { ...tempColumnFilterOne };
                tempColumnFilterOne = {};
            } else {
                // if the item is getting unchecked that may be in a part of appliedList or checkedList ( we need to hydrate the checklist for consistency )
                // but need to keep in mind untill apply button is pressed don't remove or add to the appliedList
                // That means if item is in the applied list it must be on the checklist
                // on press of apply Button Checked list's data is copied to the Applied list
                let tempColumnFilterOne = { ...state[columnFilterName] };
                let i = 0;
                // eslint-disable-next-line no-plusplus
                for (i; i < tempColumnFilterOne[columnName].checkedList.length; i++) {
                    if (tempColumnFilterOne[columnName].checkedList[i].id === data.id) {
                        break;
                    }
                }
                tempColumnFilterOne[columnName].checkedList.splice(i, 1);

                state[columnFilterName] = { ...tempColumnFilterOne };

                tempColumnFilterOne = {};
            }
        },
        clearUnsavedCheckList(state, action) {
            const { columnName, listType, columnFilterName } = action.payload;
            if (columnName && listType !== 'DATE') {
                let tempColumnFilterOne = { ...state[columnFilterName] };
                tempColumnFilterOne[columnName].checkedList = [...tempColumnFilterOne[columnName].appliedList];
                state[columnFilterName] = { ...tempColumnFilterOne };
                tempColumnFilterOne = {};
            } else {
                // eslint-disable-next-line no-lonely-if
                if (columnName) {
                    // DATE list-type
                    let tempColumnFilterOne = { ...state[columnFilterName] };
                    if (tempColumnFilterOne[columnName].appliedList.length > 0) {
                        // make checklist same as applied list on close of menu
                        tempColumnFilterOne[columnName].checkedList = [...tempColumnFilterOne[columnName].appliedList];
                        state[columnFilterName] = { ...tempColumnFilterOne };
                        tempColumnFilterOne = {};
                    } else {
                        tempColumnFilterOne[columnName].checkedList = [
                            {
                                startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                                endDate: dayjs(new Date()).format('MM-DD-YYYY')
                            }
                        ];
                        state[columnFilterName] = { ...tempColumnFilterOne };
                        tempColumnFilterOne = {};
                    }
                }
            }
        },
        updateAppliedList(state, action) {
            const { updateType, columnName, listType, columnFilterName } = action.payload;
            let tempColumnFilterOne = { ...state[columnFilterName] };
            if (updateType === 'UPDATE') {
                // new checked list moves to the applied list
                // need to avoid dublicate values
                if (listType === 'DATE') {
                    tempColumnFilterOne[columnName].appliedList = [
                        {
                            startDate: tempColumnFilterOne[columnName].checkedList[0].startDate,
                            endDate: tempColumnFilterOne[columnName].checkedList[0].endDate
                        }
                    ];
                } else {
                    tempColumnFilterOne[columnName].appliedList = [];
                    tempColumnFilterOne[columnName].checkedList.forEach((item) => {
                        //  if (!tempExistingAppliedListObj[item.id])
                        tempColumnFilterOne[columnName].appliedList.push(item);
                    });
                }

                state[columnFilterName] = { ...tempColumnFilterOne };
                // tempExistingAppliedListObj = {};
            } else if (updateType === 'CLEAR') {
                if (listType === 'DATE') {
                    tempColumnFilterOne[columnName].appliedList = [];
                    tempColumnFilterOne[columnName].checkedList = [
                        {
                            startDate: dayjs(new Date(new Date() - 24 * 60 * 60 * 1000)).format('MM-DD-YYYY'),
                            endDate: dayjs(new Date()).format('MM-DD-YYYY')
                        }
                    ];
                } else {
                    tempColumnFilterOne[columnName].appliedList = [];
                    tempColumnFilterOne[columnName].checkedList = [];
                }
            }
            tempColumnFilterOne = {};
        },
        // table filters

        completedAction(state, action) {
            state.isLoading = false;
        }
    }
});
// Actions Exports
export const {
    setPage,
    setRowsPerPage,
    // invoice
    setRowsPerPageInvoice,
    setPageInvoice,
    //
    setPageCertificate,
    setRowsPerPageCertificate,
    //
    startAddingNewCostingCard,
    startAllCostingCards,
    setCostCard,
    startCustomerCostingDetails,
    setCustomerCostingDetails,
    //
    startStandardCostingCard,
    setStandardCostingCards,
    //
    setNewCardName,
    startMakingDefaultCosting,
    // Invoicing
    startInvoiceList,
    setInvoiceList,
    startCertificateList,
    setCertificateList,
    startAddingNewInvoice,
    startInvoiceDetailsById,
    setInvoiceDetails,
    setGeneratedId,
    completedAction,
    setIsLoading,
    updateAppliedList,
    clearUnsavedCheckList,
    setColumnCheckedList
} = slice.actions;
// Reducer
export default slice.reducer;

// selectors

const costingStates = (state) => state.costingInvoicing;
/// Data Loading Selector
export const isLoadingSelector = createSelector([costingStates], (costingDataState) => costingDataState.isLoading);
// Customer Costing Details
export const customerCostingDetailsSelector = createSelector(
    [costingStates],
    (costingDataState) => costingDataState.customerCostingDetails
);
// Cost Card
export const costCardSelector = createSelector([costingStates], (costingDataState) => costingDataState.costCard);
// Standard Costing
//  New Card Name
export const newCardNameSelector = createSelector([costingStates], (costingDataState) => costingDataState.newCardName);
export const standardCostingSelector = createSelector([costingStates], (costingDataState) => costingDataState.standardCosting);
// Page Selector
export const pageSelector = createSelector([costingStates], (costingDataState) => costingDataState.page);
// Row Per Page Selector
export const rowsPerPageSelector = createSelector([costingStates], (costingDataState) => costingDataState.rowsPerPage);

// Page Selector Invoice
export const pageInvoiceSelector = createSelector([costingStates], (costingDataState) => costingDataState.pageInvoice);
// Row Per Page Selector Invoice
export const rowsPerPageInvoiceSelector = createSelector([costingStates], (costingDataState) => costingDataState.rowsPerPageInvoice);

// Page Selector Certificate
export const pageSelectorCertificate = createSelector([costingStates], (costingDataState) => costingDataState.pageCertificate);
// Row Per Page Selector Certificate
export const rowsPerPageSelectorCertificate = createSelector(
    [costingStates],
    (costingDataState) => costingDataState.rowsPerPageCertificate
);
// Invoice-List
export const invoiceListSelector = createSelector([costingStates], (costingDataState) => costingDataState.invoiceList);
// certificate list
export const certificatesListSelector = createSelector([costingStates], (costingDataState) => costingDataState.certificatesList);
// invoice Details
export const invoiceDetailsSelector = createSelector([costingStates], (costingDataState) => costingDataState.invoiceDetails);
// generated Invoice Id
export const generatedInvoiceIdSelector = createSelector([costingStates], (costingDataState) => costingDataState.generatedInvoiceId);

// column Filter
export const columnFilterSelector = createSelector([costingStates], (costingDataState) => costingDataState.columnFilter);
